import {css} from '@emotion/react'
import styled from '@emotion/styled'
import {ThemeType} from 'types/Theme'

import {
  StartIconsWrapper,
  TextInput
} from '@daedalus/atlas/src/components/designSystem/InputText'

export const IconWrapper = styled('div')``

export const searchInputBaseStyles = ({
  theme,
  borderRadius
}: {
  theme: ThemeType
  borderRadius?: number
}) => css`
  ${TextInput} {
    border-radius: ${borderRadius ? borderRadius : theme.layout.radius.lg}px;
    background: ${theme.colors.background.neutral.c000} !important;

    :focus {
      ~ ${StartIconsWrapper} {
        color: ${theme.colors.border.interactive.c500};
      }
    }
  }
`
